import styles from './BurgerMenuContent.module.sass'
import cn from "classnames";
import LogoWordmark_SVG from "@/components/svg/Global/LogoWordmark_SVG";
import MenuLink from "@/components/Footer/MenuLink";
import Button from "@/components/Button/Button";
import {useGameContext} from "@/context/GameContext";
import Arrow_SVG from "@/components/svg/Global/Arrow_SVG";
import Image from "next/image";

const BurgerMenuButton = ({className, isMenuOpen, setIsMenuOpen, ...props}) => {

	const {isContactPopupOpen, setIsContactPopupOpen, gameTimelineRef, isRestart, setIsRestart, setIsPlaying, setIsMenuScrolling} = useGameContext()

	return (
			<div className={cn(styles.burger_menu, className, {[styles.opened]: isMenuOpen})} {...props}>
				{/*Image Background*/}
				<div className={styles.background_image__wrapper}>
					<Image src={'/images/Cards/sacha_background.webp'} alt={"Menu Background"}
					       className={styles.background_image}
					       width={630} height={462}
					       unoptimized={true}
					/>
				</div>

				{/*Logo*/}
				<LogoWordmark_SVG className={styles.logo}/>

				{/*Menu*/}
				<div className={styles.menu}>
					<div className={styles.menu__links}>
						<MenuLink className={styles.menu__link} arrowColor={'#EBFD6B'} text={"Restart"} onClick={() => {
							setIsMenuScrolling(true)
							lenis.scrollTo(0, {immediate: true, onComplete: () => {
									gameTimelineRef.current.restart().pause()
									setIsMenuScrolling(false)
								}})
							setIsPlaying(true)
							setIsMenuOpen(false)
							setIsRestart(!isRestart)
						}}/>
						<MenuLink className={styles.menu__link} arrowColor={'#EBFD6B'} text={"Inventaire"} onClick={() => {
							setIsMenuScrolling(true)
							const href = Math.ceil(((gameTimelineRef.current.labels['book__content_appeared'] + 1) / gameTimelineRef.current.duration()) * (gameTimelineRef.current.scrollTrigger.end))
							lenis.scrollTo(href, {lock: true, onComplete: () => {
									setIsMenuScrolling(false)
								}})
							setIsPlaying(true)
							setIsMenuOpen(false)
						}}/>
						<MenuLink className={styles.menu__link} arrowColor={'#EBFD6B'} text={"Fiches Perso"} href={'#cards'} setIsMenuOpen={setIsMenuOpen}/>
					</div>

					{/*Contact*/}
					<div onClick={() => {
						setIsContactPopupOpen(!isContactPopupOpen)
					}}>
						<Button className={styles.contact}
						        height={'3rem'}
						        borderSize={'1.25px'}
						        gradientPercentage={'85%'}
						        buttonPadding={'1.5rem'}
						>

							<div className={styles.button_content}>
								<div className={styles.text}>Contact</div>
								<Arrow_SVG className={styles.arrow} color={'#0D422E'}/>
							</div>
						</Button>
					</div>
				</div>

				{/*Footer text*/}
				<div className={styles.footer_text}>
					<div className={styles.upper}>
						<span>Made with </span>
						<Image src="/Global/SingleHeart.png"
						       alt="Heart"
						       width={16} height={16}
						       className={styles.heart_image}/>
					</div>
					<span>Webdesign by <a className={'custom_pointer'}
                            href={"https://gax.design/"}
                            target={"_blank"}>GAX - Creative Studio</a><br/> & Developement by <a
							className={'custom_pointer'}
							href={"https://ziben.fr/"}
							target={"_blank"}>Ziben</a></span>
				</div>
			</div>
	)
}
export default BurgerMenuButton;